import type { PoyntSaleBackfillRepository } from "./poynt_sale_backfill_bloc";
import { createJobRepository } from "./job_repository";
import { VisibilityPoller } from "./job_polling";

const jobs = createJobRepository("poynt-sale-backfill");

export const poyntSaleBackfillRepository: PoyntSaleBackfillRepository = {
  kickoff: (input) => jobs.kickoff({ ...input }),

  /**
   * Polls rather than subscribes: the job is a single short pass whose only
   * interesting state is the last one, and a missed subscription event would
   * leave the sheet waiting forever. A failed read is retried on the next tick;
   * a tick that comes while a read is pending is skipped.
   */
  watch(jobId, onJob) {
    let stopped = false;
    let reading = false;
    const tick = () => {
      if (reading) return;
      reading = true;
      jobs
        .getJob(jobId)
        .then((job) => {
          if (!stopped && job) onJob(job);
        })
        .catch(() => {})
        .finally(() => {
          reading = false;
        });
    };
    const poller = new VisibilityPoller(tick);
    poller.start();
    tick();
    return () => {
      stopped = true;
      poller.stop();
    };
  },
};
